var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrevinline = function SvgPrevinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M30.266 19.995H9.95m8.349 8.67L9.3 19.995l8.999-8.66M.622 19.994C.622 9.413 9.201.835 19.783.835s19.16 8.578 19.16 19.16-8.578 19.161-19.16 19.161S.623 30.578.623 19.996Z"
  })));
};
export default SvgPrevinline;